import { useState, useEffect } from "react";
// redux
import { useSelector } from "react-redux";
//axios
import EnhancedAxios from "../../../api/EnhancedAxios";
// mui
import { Stack, Box, Typography } from "@mui/material";
// hooks
import { usePageParams } from "../../../hooks/usePageParams";
// components
import {
    PageTitle,
    RingsLoader,
    SearchBox,
    SortBox,
    DisableStatusFilterBox,
    LinkButton,
} from "../../../components";
import { TableGrid } from "../../../sections";
import { operatorCols } from "../../../utils/gridCols/operatorCols";
// alerts
import { errorAlert } from "../../../utils/alerts";
// icons
import { MdAdd } from "react-icons/md";

const Operators = () => {
    const userToken = useSelector((state) => state.userToken);
    const [loading, setLoading] = useState(true);
    const [operators, setOperators] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [totalItems, setTotalItems] = useState(20);
    const [searchValue, setSearchValue] = useState("");
    const [sortValue, setSortValue] = useState("-created_at");
    const [filterValues, setFilterValues] = useState({
        status: "is_disabled:eq:false",
    });
    const { page, setPage } = usePageParams();
    // get all drivers
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `admin/users?filters=roles:7,is_anon:false,${filterValues.status}&page=${page}&paginate=${itemsPerPage}&q=${searchValue}&sorts=${sortValue}`
            )
            .then((res) => {
                setOperators(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error) => errorAlert(error));
    }, [page, filterValues, itemsPerPage, sortValue, searchValue]);
    // page ui
    return (
        <Stack gap="20px">
            <PageTitle title="إدارة مسؤلين العمليات" />
            <Stack gap="20px">
                <Box
                    width="100%"
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    gap="20px"
                    flexWrap="wrap"
                >
                    <LinkButton
                        text="اضافة"
                        to="/add-operator"
                        icon={<MdAdd />}
                    />
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap="20px"
                    flexWrap="wrap"
                >
                    <SearchBox
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />
                    <SortBox
                        sortValue={sortValue}
                        setSortValue={setSortValue}
                    />
                    <DisableStatusFilterBox
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                    />
                </Box>
            </Stack>
            <Stack>
                {loading ? (
                    <RingsLoader />
                ) : operators.length === 0 && searchValue === "" ? (
                    <Typography variant="body1" textAlign="center">
                        لا يوجد عناصر لعرضها.
                    </Typography>
                ) : operators.length === 0 && searchValue !== "" ? (
                    <Typography variant="body1" textAlign="center">
                        {" "}
                        لا يوجد عناصر لعرضها خاصة نتيجة البحث.
                    </Typography>
                ) : (
                    <TableGrid
                        rows={operators}
                        cols={operatorCols}
                        itemsPerPage={itemsPerPage}
                        totalItems={totalItems}
                        currentPage={page}
                        setCurrentPage={setPage}
                    />
                )}
            </Stack>
        </Stack>
    );
};

export default Operators;
